import { z } from "zod";
import { DTODocumentationItemConfigurationV2 } from "./item-configuration-v2";

export const DTODocumentationDraftChangeType = z.enum(["Created", "Updated", "Deleted"]);

export const DTODocumentationDraftStateCreated = z.object({
  changeType: z.literal(DTODocumentationDraftChangeType.enum.Created),
});

export const DTODocumentationDraftStateUpdated = z.object({
  changeType: z.literal(DTODocumentationDraftChangeType.enum.Updated),
  changes: z.object({
    previousTitle: z.string().optional(),
    previousConfiguration: DTODocumentationItemConfigurationV2.optional(),
    previousContentHash: z.string().optional(),
  }),
});

export const DTODocumentationDraftStateDeleted = z.object({
  changeType: z.literal(DTODocumentationDraftChangeType.enum.Deleted),
  deletedAt: z.coerce.date(),
  deletedByUserId: z.string(),
});

export const DTODocumentationDraftState = z.discriminatedUnion("changeType", [
  DTODocumentationDraftStateCreated,
  DTODocumentationDraftStateUpdated,
  DTODocumentationDraftStateDeleted,
]);

export type DTODocumentationDraftChangeType = z.infer<typeof DTODocumentationDraftChangeType>;

export type DTODocumentationDraftStateCreated = z.infer<typeof DTODocumentationDraftStateCreated>;
export type DTODocumentationDraftStateUpdated = z.infer<typeof DTODocumentationDraftStateUpdated>;
export type DTODocumentationDraftStateDeleted = z.infer<typeof DTODocumentationDraftStateDeleted>;

export type DTODocumentationDraftState = z.infer<typeof DTODocumentationDraftState>;
